export default {
  welcome: "Welcome",
  hi: "Hello",
  base: {
    here: "Here",
    username: "Username",
    password: "Password",
    default: "Default",
    created_at: "Created time",
    status: "Status",
    proxy: "Proxy",
    proxy_status: "Proxy status",
    config_proxy: "Proxy configuration",
    link_shop: "Link Shop account",
    linked_shop: "Shop linked",
    optional: "Optional",
    action: "Action",
    actions: "Actions",
    good: "Good",
    error: "Error",
    connect_platform: "Connect to Platforms",
    active: "Active",
    deactivate: "Inactive",
    open: "Open",
    close: "Close",
    confirm: "Confirm",
    reject: "Reject",
    accept: "Accept",
    otp_code: "OTP Code",
    save_config: "Save Configuration",
    delete_config: "Delete Configuration",
    edit_config: "Edit Configuration",
    edit_x_config: "Edit {x} Configuration",
    mass_save_config: "Save Mass Configuration",
    delete_mass_config: "Delete Mass Configuration",
    mass_edit_config: "Edit Mass Configuration",
    mass_edit_x_config: "Edit {x} Mass Configuration",
    save_file: "Save File",
    save_x_file: "Save {x} File",
    delete_file: "Delete File",
    mass_delete_file: "Delete Mass Files",
    has_an_occurred: "An error has occurred",
    save_config_success: "Configuration saved successfully",
    connect_config_success: "Configuration connected successfully",
    connect_config_error: "Configuration connection failed",
    has_error: "An error occurred",
    invalid_file_format: "Invalid file format",
    cancel: "Cancel",
    attention: "Attention",
    confirm_delete_x: "Are you sure you want to delete {x}?",
    delete_x_success: "Successfully deleted {x}",
    save_x_success: "Successfully saved {x}",
    edit_x_success: "Successfully edited {x}",
    create: "Create",
    create_new: "Create New",
    edit: "Edit",
    update: "Update",
    delete: "Delete",
    profile: "Account information",
    change_password: "Change Password",
    change_password_note: "Changing the password will require re-login.",
    balance: "Balance",
    pack: "Package",
    display_name: "Display Name",
    phone_number: "Phone Number",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    confirmed: "Confirmed",
    rejected: "Rejected",
    receiver: "Receiver",
    send_at: "Sent time",
    state: "State",
    pending: "Pending",
    pending_confirm: "Pending Confirmation",
    sent: "Sent",
    channel: "Channel",
    select_all: "Select All",
    confirm_action: "Are you sure you want to perform this action?",
    config: "Configuration",
    keyword: "Keyword",
    keywords: "Keywords",
    select_top_x_y: "Select top {x} {y}",
    unselect_all_x: "Unselect all {x}",
    download_excel: "Download Excel File",
    export_excel: "Export to Excel",
    add_selected_x: "Add Selected {x}",
    delete_selected_x: "Delete Selected {x}",
    import_from_excel: "Import from Excel",
    delete_all_x: "Delete All {x}",
    filename: "Filename",
    volume: "Search Volume",
    recommend_price: "Recommended Price",
    your_price: "Your Price",
    x_selected: "{x} Selected",
    add: "Add",
    at: "at",
    error_reading_file: "An error occurred while reading the file",
    create_at_least_product:
      "Please post at least one product to use this feature!",
    filter: "Filter",
    compare_data: "Compare Data",
    expanded_search: "Expanded Search",
    exact_search: "Exact Search",
    relevance: "Keyword Quality",
    shopee_volume: "Shopee Search Volume",
    column: "Column Name",
    expression: "Expression",
    value: "Value",
    delete_filter: "Delete filter",
    execute: "Execute",
    shopee_price: "Shopee Bid Price",
    mobile: "Mobile",
    desktop: "Desktop",
    total: "Total",
    start_time: "Start Time",
    end_time: "End Time",
    product: "Product",
    settings: "Settings",
    on: "On",
    off: "Off",
    turn_on: "Turn On",
    turn_off: "Turn Off",
    select_plan_file: "Select Plan File",
    export_data: "Export Data",
    campaign: "Campaign",
    campaign_detail: "Campaign Detail",
    select: "Select",
    x_on_current_page: "{x} on current page",
    reload: "Reload",
    reload_data: "Reload Data",
    basic: "Basic",
    base: "Base",
    applying: "Applying",
    applying_x: "Applying {x}",
    not_applying_x: "Not Applying {x}",
    ongoing: "Ongoing",
    paused: "Paused",
    ended: "Ended",
    deleted: "Deleted",
    out_stock: "Out of Stock",
    from: "From",
    to: "To",
    no_end_date: "No End Date",
    unselect: "Unselect",
    budget: "Budget",
    low_budget: "Low Budget",
    unlimited: "Unlimited",
    daily_budget: "Daily Budget",
    total_budget: "Total Budget",
    select_tags: "Select tags",
    add_tags: "Add tags",
    remove_tags: "Remove tags",
    type: "Type",
    tags_added: "Tags added",
    no_tags_added: "No tags added",
    create_tags: "Create tags",
    update_tags: "Update tags",
    delete_tags: "Delete tags",
    add_tags_for_selected_x: "Add tags for selected {x}",
    remove_tags_of_selected_x: "Remove tags of selected {x}",
    pause: "Pause",
    resume: "Resume",
    end: "End",
    stop: "Stop",
    setup_x: "Setup {x}",
    restart: "Restart",
    all: "All",
    clone_x: "Clone {x}",
    copy_x: "Copy {x}",
    calculate_from: "Calculate From",
    shopee_recommend_price: "Shopee Recommended Price",
    current_price: "Current Price",
    i_or_d: "Increase or Decrease",
    increase: "Increase",
    decrease: "Decrease",
    percent: "Percent",
    amount: "Amount",
    apply: "Apply",
    i_or_d_type: "Increase/Decrease Type",
    select_start_time: "Select Start Time",
    select_end_time: "Select End Time",
    set_budget: "Set Budget",
    getting_data: "Getting Data",
    loading_data: "Loading Data",
    selected: "Selected",
    category: "Category",
    shop_category: "Shop Category",
    show_eligible_products_only: "Show Eligible Products Only",
    image: "Image",
    monthly_sales: "Monthly Sales",
    monthly_gmv: "Monthly revenue",
    revenue: "Revenue",
    sales: "Sales",
    price: "Price",
    stock: "Stock",
    configuration_setup_guide: "Configuration Setup Guide",
    minimum: "Minimum",
    maximum: "Maximum",
    not_required: "Not Required",
    select_duration: "Select Test Duration",
    today: "Today",
    yesterday: "Yesterday",
    last_week: "Last Week",
    last_month: "Last Month",
    date_range: "Start Date - End Date",
    save_configuration: "Save Configuration",
    display_by_selected_metrics: "Display by Selected Metrics",
    save_filter: "Save Filter",
    use_saved_filter: "Use Saved Filter",
    mass_edit_x: "Mass Edit {x}",
    i_or_d_x_by_amount: "Increase/Decrease {x} by Amount",
    i_or_d_x_by_percent: "Increase/Decrease {x} by Percent",
    budget_type: "Budget Type",
    select_budget_type: "Select Budget Type",
    set_x: "Set {x}",
    bid_price: "Bid Price",
    use_recommend_price: "Use Recommended Price",
    use_cpc: "Use CPC",
    select_cpc_duration: "Select CPC Duration",
    set_bid_price: "Adjust Bid Price",
    higher: "Higher",
    lower: "Lower",
    configuration_runtime_list: "Runtime List",
    starting_at: "Starting At",
    ending_at: "Ending At",
    starting_time: "Starting Time",
    ending_time: "Ending Time",
    select_all_day: "Select All Day",
    set_when_outside_runtime: "Adjust When Outside of Setup Hours",
    keep_bid_price: "Keep Bid Price",
    pause_keyword: "Pause Keyword",
    resume_keyword: "Resume Keyword",
    delete_keyword: "Delete Keyword",
    set_amount: "Set Amount",
    max_bid_price: "Max Bid Price",
    advanced_max_bid_price: "Advanced Max Bid Price",
    min_bid_price: "Min Bid Price",
    bonus_amount: "Bonus Amount",
    deduction_amount: "Deduction Amount",
    from_current_bid_price: "from Current Bid Price",
    of_current_bid_price: "of Current Bid Price",
    current_duration: "Current Duration",
    expected_cir: "Desired CIR Ratio",
    starting_bid_price: "Starting Bid Price",
    from_date: "From Date",
    to_date: "To Date",
    disable_compare_data: "Disable Data Comparison",
    set_by_x: "Adjust by {x}",
    edit_by_x: "Edit by {x}",
    starting_budget: "Starting Budget",
    not_recommended: "Not Recommended",
    edit_bid_price: "Edit Bid Price",
    added: "Added",
    add_config: "Add Configuration",
    configuration_list: "Configuration List",
    search: "Search",
    action_plan: "Action Plan",
    increase_type: "Increase Type",
    decrease_type: "Decrease Type",
    increase_by_amount: "Increase by Amount",
    increase_by_percent: "Increase by Percent",
    decrease_by_amount: "Decrease by Amount",
    decrease_by_percent: "Decrease by Percent",
    max_cost: "Max Cost",
    applied_keyword_type: "Applied Keyword Type",
    conditions_for_applying: "Conditions for Applying",
    automatic_i_or_d: "Automatic Increase/Decrease",
    i_or_d_by_amount: "Increase/Decrease by Amount",
    i_or_d_by_percent: "Increase/Decrease by Percent",
    update_to_starting_bid_price: "Update to Starting Bid Price",
    automatic: "Automatic",
    by_amount: "By Amount",
    by_percent: "By Percent",
    update_keyword_by_conditions: "Update Keywords by Conditions",
    condition: "Condition",
    conditions: "Conditions",
    add_condition: "Add Condition",
    increase_amount: "Increase Amount",
    increase_bid_price: "Increase Bid Price",
    decrease_amount: "Decrease Amount",
    decrease_bid_price: "Decrease Bid Price",
    set_by_cpc: "Adjust Bid Price by CPC",
    change_to_exact: "Change to Exact Match",
    change_to_broad: "Change to Broad Match",
    conditions_and_actions: "Conditions & Actions",
    add_conditions_actions: "Add Conditions & Actions",
    use_file: "Use File",
    saved_files: "Saved Files",
    use: "Use",
    create_new_file: "Create New File",
    update_existed_file: "Update Existing File",
    update_campaign_status: "Update Campaign Status",
    update_campaign_status_message:
      "This option only applies to campaigns that are completely stopped.",
    pause_ads: "Pause Ads",
    daily_discover: "Daily Suggestions",
    you_may_also_like: "You May Also Like",
    mass_resume_configuration: "Mass Resume Configuration",
    mass_pause_configuration: "Mass Pause Configuration",
    mass_delete_configuration: "Mass Delete Configuration",
    conditions_actions_template: "Conditions & Actions Template",
    create_manual_rules: "Create Manual Rules",
    auto_position_and_optimize_cir_template:
      "Auto Positioning + CIR Optimization Template",
    auto_budget_template: "Auto Budget Optimization by CIR Template",
    conditions_groups: "Conditions Groups",
    conditions_group: "Conditions Group",
    level: "Level",
    audience: "Audience",
    include_tags: "Include Tags",
    cost_and_budget_rate: "Cost/Budget Rate",
    and: "And",
    or: "Or",
    add_x: "Add {x}",
    do_nothing: "Do Nothing",
    increase_budget: "Increase Budget",
    decrease_budget: "Decrease Budget",
    resume_campaign: "Resume Campaign",
    pause_campaign: "Pause Campaign",
    clone_campaign: "Clone Campaign",
    set_budget_by_realtime_cost: "Set Budget by Real-Time Cost",
    max_budget: "Max Budget",
    min_budget: "Min Budget",
    resume_ad: "Resume Ads",
    pause_ad: "Pause Ad",
    note: "Note",
    setup_operation_rules: "Set Up Operation Rules",
    config_name: "Configuration Name",
    update_config_file: "Update Configuration File",
    applying_config_list: "Applying Configuration List",
    saved_config_list: "Saved Configuration List",
    installed_config_list: "Installed Configuration List",
    automatic_by_condition_configuration_list:
      "Automatic Configuration by Condition List",
    continuously: "Continuously",
    once_a_day: "Once a Day",
    condition_action_number: "Condition & Action Number",
    only_show_me: "Only Show Me This Configuration",
    view_activity_history: "View Activity History",
    config_file: "Configuration File",
    share: "Share",
    convert_automatic_config_to_automatic_condition:
      "Convert Automatic Configuration to Condition-Based Configuration",
    manage_tags: "Manage Tags",
    filter_name: "Filter Name",
    saved_filter_list: "Saved Filter List",
    config_file_name: "Configuration File Name",
    config_code: "Configuration Code",
    error_code: "Error Code",
    time: "Time",
    targeting: "Targeting",
    copy: "Copy",
    use_starting_bid_price: "Use Starting Bid Price",
    import_config_success: "Configuration Imported Successfully",
    config_not_found: "Configuration Not Found",
    update_file_confirm: "Are you sure you want to update this file?",
    delete_file_confirm: "Are you sure you want to delete this file?",
    update_success: "Update Successful",
    save_success: "Save Successful",
    delete_success: "Delete Successful",
    edit_success: "Edit Successful",
    clone_confirm: "Are you sure you want to clone this campaign?",
    delete_filter_confirm: "Are you sure you want to delete this filter?",
    delete_tags_confirm: "Are you sure you want to delete this tag?",
    use_condition_template_message:
      "Are you sure you want to use this template? Note that current settings will be replaced.",
    convert_to_condition_message:
      "Are you sure you want to switch to condition-based configuration? Note that old configurations will be paused.",
    delete_config_confirm:
      "Are you sure you want to delete this configuration?",
    delete_config_success: "Configuration Deleted Successfully",
    delete_multiple_config_confirm:
      "Are you sure you want to delete these configurations?",
    save_config_confirm: "Are you sure you want to save this configuration?",
    invalid_data: "Invalid Data",
    update_config_status_confirm:
      "Are you sure you want to change the status of this configuration?",
    y_gte_than_x: "{y} must be greater than or equal to {x}",
    y_gt_than_x: "{y} must be greater than {x}",
    y_lte_than_x: "{y} must be less than or equal to {x}",
    y_lt_than_x: "{y} must be less than {x}",
    y_eq_x: "{y} must be equal to {x}",
    y_ne_x: "{y} is not equal to {x}",
    y_gte_x: "{y} must be greater than or equal to {x}",
    y_gt_x: "{y} must be greater than {x}",
    y_lte_x: "{y} must be less than or equal to {x}",
    y_lt_x: "{y} must be less than {x}",
    update_data_confirm: "Are you sure you want to update this data?",
    update_data_success: "Data Updated Successfully",
    need_up_to_pro_package:
      "You need to upgrade to PRO or higher package to use this feature.",
    update_keywords_success: "Keywords Updated Successfully",
    runtime_is_used:
      "The runtime has been used. Please select another active date.",
    update_keyword_by_cir_confirm:
      "Are you sure you want to update keywords by CIR?",
    add_keywords_confirm:
      "Are you sure you want to add keywords to this campaign?",
    keywords_result_not_found: "No results found for keywords",
    update_bid_price_confirm: "Are you sure you want to update the bid price?",
    hours: "hours",
    minutes: "minutes",
    the_next_day: "the next day",
    create_campaign_confirm:
      "Are you sure you want to create this ad campaign?",
    create_campaign_success: "Campaign created successfully",
    max_clicks: "Maximum Clicks",
    min_clicks: "Minimum Clicks",
    ratio: "Ratio",
    back: "Back",
    create_new_campaign: "Create New Campaign",
    basic_settings: "Basic Settings",
    products: "Products",
    campaign_name: "Campaign Name",
    ad_name: "Advertising Name",
    tagline: "Tagline",
    set_start_end_date: "Set Start/End Date",
    bidding: "Bidding",
    optional_bidding: "Customize bidding according to your preferences.",
    manual_bidding: "Manual bidding",
    keyword_selection: "Keyword selection",
    shopee_recommend: "Shopee recommendation",
    search_keywords: "Search keywords",
    use_saved_bid_price: "Use saved bid price",
    use_shopee_bid_price: "Use Shopee bid price",
    saved_bid_price: "Saved bid price",
    shopee_bid_price: "Shopee bid price",
    remove_duplicated_keywords: "Remove duplicate keywords",
    duration: "Duration",
    discovery: "Discovery",
    select_products: "Select Products",
    manually_select_products: "Manually select Products",
    choose_specific_products_message:
      "Select specific products to run ads based on your goals.",
    add_products: "Add Products",
    add_recommend_products: "Add Recommended Products",
    code: "Code",
    id: "ID",
    ratings: "Ratings",
    see_detail: "See details",
    running_ads: "Running Ads",
    let_shopee_do:
      "Shopee will optimize your ad display for shoppers, helping you achieve the highest efficiency.",
    bidding_settings_manually:
      "Customize bidding according to your preferences.",
    target_roas: "Target ROAS",
    set_your_own_roas: "Set Your Own ROAS",
    discovery_locations: "Discovery locations",
    audience_targeting: "Audience",
    auto_targeting: "Automatic",
    manual_targeting: "Manual",
    custom_audience: "Custom Audience",
    new_custom_audience: "New Custom Audience",
    age: "Age",
    gender: "Gender",
    buyer_type: "Customer Segment",
    premium_rate: "Premium Rate (%)",
    all_products: "All Products",
    not_creating_ads: "No Ads Created",
    men: "Men",
    women: "Women",
    potential_new_buyers: "Potential New Buyers",
    sold: "Sold",
    product_campaign_detail: "Product Ad Details",
    shop_campaign_detail: "Shop Ad Details",
    placement: "Placement",
    shopee_advanced_settings: "Shopee Advanced Settings",
    shopee_advanced_settings_note:
      "To optimize conversions, let Shopee automatically adjust your bid.",
    turning_on: "Turning On",
    turning_off: "Turning Off",
    mass_edit_bid_price: "Mass Edit Bid Price",
    mass_update_keywords: "Mass Update Keywords",
    update_keywords_by_conditions: "Update Keywords by Conditions",
    change_keywords_type: "Change Keywords Type",
    change_keywords_status: "Change Keywords Status",
    mass_change_keywords_type: "Mass Change Keywords Type",
    mass_change_keywords_status: "Mass Change Keywords Status",
    mass_delete_keywords: "Mass Delete Keywords",
    delete_keywords: "Delete Keywords",
    advanced: "Advanced",
    other_options: "Other Options",
    download_x_file: "Download {x} File",
    selected_keywords: "Selected Keywords",
    shopee_report: "Shopee Report",
    auto_bidding: "Auto Bidding",
    restore: "Restore",
    installed: "Installed",
    not_installed: "Not Installed",
    update_bid_price: "Update Bid Price",
    edit_target_roas: "Edit Target ROAS",
    edit_audience: "Edit Audience",
    audience_name: "Audience Name",
    bonus_premium_rate: "Bonus Premium Rate",
    max_premium_rate: "Maximum Premium Rate",
    reduction_premium_rate: "Reduction Premium Rate",
    min_premium_rate: "Minimum Premium Rate",
    enhanced_bid_price: "Enhanced Bid Price",
    change_placement_confirm:
      "Are you sure you want to change the ad placement?",
    precomposed: "Precomposed",
    combining: "Combining",
    cannot_export_report: "Cannot Export Report",
    delete_campaign_confirm:
      "Are you sure you want to delete this campaign? Deleted ads cannot be restored! You can still view the data of deleted ads for 2 weeks, after which they will be permanently removed from the system.",
    edit_campaign: "Edit Campaign",
    shop_page: "Shop Homepage",
    add_keyword_success: "Keyword Added Successfully",
    min: "Minimum",
    bid_price_per_click: "Bid Price per Click",
    setup: "Setup",
    exact: "Exact",
    broad: "Broad",
    update_campaign: "Update Campaign",
    edit_image: "Edit Image",
    all_data: "All Data",
    discovery_placement: "Discovery Placement",
    all_placements: "All Placements",
    lookup: "Lookup",
    created_time: "Created Time",
    timestamp: "Timestamp",
    old_data: "Old Data",
    new_data: "New Data",
    view_data_detail: "View Data Details",
    analyze: "Analyze",
    analyze_data: "Analyze Data",
    upload_report: "Upload Report File",
    search_query: "Search Query",
    query: "Query",
    search_query_volume: "Search Query Volume",
    past1week: "Past Week",
    past1month: "Past Month",
    past3months: "Past 3 Months",
    since_begin_week: "Since Beginning of Week",
    since_begin_month: "Since Beginning of Month",
    ads_metrics: "Ads Metrics",
    overview_metrics: "Shop Overview Metrics",
    chart: "Chart",
    sales_metrics: "Sales Metrics",
    buyer_info: "Buyer Information",
    total_buyers: "Total Buyers",
    new_buyers: "New Buyers",
    followers: "Followers",
    existing_buyers: "Repeat Buyers",
    repeat_purchase_rate: "Repeat Purchase Rate",
    funnel_sales: "Funnel Sales",
    previous_day: "Previous Day",
    buyers: "Buyers",
    basic_info: "Basic Information",
    products_info: "Product Information",
    update_products: "Update Products",
    change_product_name_confirm:
      "Are you sure you want to change the product name?",
    update_product_name_success: "Product Name Updated Successfully",
    data: "Data",
    month: "Month",
    year: "Year",
    sku: "SKU",
    model: "Model",
    variations: "Variations",
    variation_list: "Variation List",
    variation_name: "Variation Name",
    period: "Period",
    loading_products: "Loading Product List",
    mass_setup: "Mass Setup",
    info: "Information",
    old_name: "Old Name",
    new_name: "New Name",
    length: "Length",
    result: "Result",
    preview: "Preview",
    updated_at: "Updated At",
    download: "Download",
    frame: "Frame",
    frame_image: "Frame Image",
    cannot_upload_file: "Cannot Upload File",
    add_success: "Added Successfully",
    created_by: "Created By",
    upcoming: "Upcoming",
    expired: "Expired",
    time_slot: "Time Slot",
    time_slots: "Time Slots",
    copy_data: "Copy Data",
    shop: "Shop",
    update_file: "Update File",
    clone_file: "Clone File",
    edit_filename: "Edit Filename",
    import_products: "Import Products",
    mass_update: "Mass Update",
    example: "Example",
    there_are: "There are",
    there_is: "There is",
    row: "Row",
    raw: "Row",
    cannot_import_file: "Cannot Import File",
    delete_product_confirm: "Are you sure you want to delete this product?",
    mass_edit: "Mass Edit",
    discount: "Discount",
    edit_type: "Edit Type",
    limited: "Limited",
    update_selected: "Update Selected",
    mass_enable: "Mass Enable",
    variation_price: "Variation Price",
    discounted_price: "Discounted Price",
    variation: "Variation",
    show: "Show",
    selected_time_slots: "Selected Time Slots",
    selected_time_slots_list: "Selected Time Slots List",
    save_and_apply: "Save and Apply",
    discount_price: "Discount Price",
    overview: "Overview",
    ended_on: "Ended On",
    will_end_on: "Will End On",
    enable: "Enable",
    disable: "Disable",
    login_code: "Login Code",
    use_cpc_duration: "Use CPC Duration",
    wait_for_error:
      "Error. Please wait a few minutes before continuing to load data.",
    plan: "Plan",
    complete: "Complete",
    use_config_confirm: "Are you sure you want to use this configuration?",
    region: "Region",
    country: "Country",
  },
  // todo: end base

  input: {
    placeholder: "Enter search content",
    username: "Enter username",
    password: "Enter password",
    login_code: "Enter login code",
    password_for: "Enter password for",
    otp: "Enter OTP code",
    filename: "Enter filename",
    max_cost: "Enter maximum cost",
    bid_price: "Enter bid price",
    budget: "Enter budget",
    daily_budget: "Enter daily budget",
    total_budget: "Enter total budget",
    amount: "Enter amount",
    day_numbers: "Enter number of days",
    bonus_amount: "Enter bonus amount",
    deduction_amount: "Enter deduction amount",
    max_bid_price: "Enter maximum bid price",
    min_bid_price: "Enter minimum bid price",
    starting_bid_price: "Enter starting bid price",
    value: "Enter value",
    expected_cir: "Enter expected CIR rate",
    starting_budget: "Enter starting budget",
    max_budget: "Enter maximum budget",
    config_name: "Enter configuration name",
    tag_name: "Enter tag name",
    filter_name: "Enter filter name",
    config_file_name: "Enter configuration file name",
    config_code: "Enter configuration code",
    percent: "Enter percent",
    ad_name: "Enter ad name",
    tagline: "Enter tagline",
    bonus_premium_rate: "Enter bonus premium rate",
    max_premium_rate: "Enter maximum premium rate",
    premium_rate: "Enter premium rate",
    reduction_premium_rate: "Enter reduction premium rate",
    min_premium_rate: "Enter minimum premium rate",
    campaign_id: "Enter campaign ID",
    keyword: "Enter keyword",
    select_time: "Select time",
    start_time: "Select start time",
    end_time: "Select end time",
    start_month: "Select start month",
    end_month: "Select end month",
    time: "Select time",
    text: "Enter content",
    product_group_name: "Enter product group name",
    new_text: "Enter new text",
    replace_text: "Enter replacement text",
  },
  // todo: end input

  required: {
    username: "Please enter username",
    password: "Please enter password",
    select: "Please select",
    input: "Please enter content",
    select_sub_account: "Please select responsible sub-account",
    set_rule_for_sub_account: "Please assign permissions for the sub-account",
    start_time: "Please select start time",
    end_time: "Please select end time",
    amount: "Please enter amount",
    bid_price: "Please enter bid price",
    filename: "Please enter filename",
    select_file: "Please select file",
    action: "Please select action",
    action_to_handle: "Please select action to handle",
    i_or_d_type: "Please select increase/decrease type",
    i_or_d_value: "Please enter increase/decrease value",
    cpc_duration: "Please select CPC duration",
    full_filter_data: "Please enter full data for the filter",
    add_config: "Please add configuration",
    specific_day: "Please select specific day",
    expected_cir: "Please enter expected CIR rate",
    applied_keyword_type: "Please select applied keyword type",
    min_bid_price: "Please enter minimum bid price",
    max_bid_price: "Please enter maximum bid price",
    max_cost_if_gmv_by_0: "Please enter maximum cost if GMV is 0",
    max_bid_price_for_exact: "Please enter maximum bid price for exact keyword",
    max_bid_price_for_broad: "Please enter maximum bid price for broad keyword",
    select_runtime: "Please select runtime",
    select_advanced_runtime: "Please select advanced runtime",
    configuration_active_day: "Please select active day",
    bonus_amount: "Please enter bonus amount",
    cir_type: "Please select CIR type",
    check_duration: "Please select check duration",
    must_select_at_least: "Please select at least 1 option",
    starting_budget: "Please enter starting budget",
    budget_type: "Please select budget type",
    budget: "Please enter budget",
    add_advanced_config: "Please add advanced configuration",
    percent_of_recommend_price: "Please enter percent of recommended price",
    full_data: "Please enter full data",
    select_products_for_creating_ad: "Please select products to create ad",
    must_select_at_least_product: "Please select at least 1 product",
    must_select_at_least_keyword: "Please select at least 1 keyword",
    select_product: "Please select product",
    ad_name: "Please enter ad name",
    ad_duration: "Please select ad campaign duration",
    bonus_premium_rate: "Please enter bonus premium rate",
    max_premium_rate: "Please enter maximum premium rate",
    reduction_premium_rate: "Please enter reduction premium rate",
    min_premium_rate: "Please enter minimum premium rate",
    premium_rate: "Please enter premium rate",
    min_premium_rate_is_x: "Minimum premium rate is {x}",
    max_premium_rate_is_x: "Maximum premium rate is {x}",
    audience_name: "Please enter audience name",
    audience_group_name: "Please enter audience group name",
    not_exceed_max:
      "Number of keywords must not exceed {x} keywords. Current number of keywords is {c}",
    tagline: "Please enter ad tagline",
    tagline_not_includes: "Your ad tagline cannot contain “!@^*{};<>”",
    campaign_id: "Please enter campaign ID",
    select_keywords: "Please select keywords",
    select_duration: "Please select duration",
    select_products_to_create: "Please select products to create",
    select_product_to_analyze: "Please select product to analyze",
    select_image_to_remove_frame: "Please select image to remove frame",
    new_product_name: "Please enter new product name",
    replace_text: "Please enter replacement text",
    new_replace_text: "Please enter new text",
    select_frame: "Please select frame",
    select_cover_image: "Please select cover image",
    select_group: "Please select group",
    group_name: "Please enter group name",
    remove_text: "Please enter text to remove",
    select_products: "Please select products",
    shop: "Please select shop",
    time_slot: "Please select time slot",
    percent: "Please enter percent",
  },
  // todo: end required

  button: {},
  // todo: end button

  select: {
    shop: "Select shop",
    compare_duration: "Select comparison time frame",
    action: "Select action",
    keyword_file: "Select keyword file",
    report_duration: "Select report time frame",
    file: "Select file",
    tags: "Select tags",
    time: "Select time",
    active_day: "Please select active day",
    campaign_type: "Select campaign type",
    ad_type: "Select ad type",
    time_period_for_analysis: "Select analysis time period",
    group: "Select group",
    time_slot: "Select time slot",
    products: "Select products",
  },
  // todo: end select

  menu: {
    shopee_shops: "Shopee Shops",
    sub_accounts: "Sub Accounts",
    atosa_packages: "Atosa Packages",
    topup_payment: "Top-up / Payment",
    shopee_ads_course: "Shopee Ads Course",
    shopee_mall_offering: "Shopee Mall Services",
    affiliate: "Affiliate Marketing",
    user_guide: "User Guide",
    download_desktop_app: "Download Desktop App",
    customer_support_channel: "Customer Support Channel",
    logout_account: "Logout",
    shop_analysis: "Competitor Analysis",
    shopee_research: "Market Research",
    ads_planning: "Ads Planning",
    order_planning: "Order Planning",
    atosa_keyword_tool: "Atosa Keyword Tool",
    automatic_ads: "Automatic Ads",
    ad_position_check: "Ad Position Spy",
    shop_products: "Shop Products",
    shop_flash_sale: "Shop Flash Sale",
    shopee_flash_sale: "Shopee Flash Sale",
    shop_vouchers: "Shop Vouchers",
    business_insights: "Sales Insights",
    ads_insights: "Ads Insights",
    monthly_reporting: "Monthly Reporting",
    customer_insights: "Customer Insights",
    shopee_analysis: "Market Research",
    planning: "Planning",
    atosa_tools: "Atosa Tools",
    shopee_ads: "Shopee Ads",
    automatic_marketing: "Automatic Marketing",
    reporting: "Reporting",
    management: "Management",
    package: "Package",
    payment: "Payment",
    operation: "Operation",
    use_basic_menu: "Use Basic Menu",
    use_advanced_menu: "Use Advanced Menu",
    select_os: "Select Operating System",
  },
  // todo: end menu

  profile: {
    note1:
      "Please update your information so we can assist you in case of issues or if you forget your password.",
  },
  // todo: end profile

  shop: {
    list: "Shop List",
    add: "Add Shop",
    add_by_code: "Add Shop by Code",
    guide: {
      1: "Guide to Adding Shops on Atosa",
      2: "Guide to Renaming Shops on Atosa",
      3: "Guide to Common Login Issues for Shops",
      4: "To restore configurations after deleting a shop, please contact customer support. Processing time is 1-2 days.",
    },
    using_system_proxy: "Using system proxy",
    login: "Login to Shop",
    re_login: "Re-login",
    delete: "Delete Shop",
    google: {
      list: "Google Account List",
      account_id: "Account ID",
      account_name: "Account Name",
      connect: "Connect Account",
      delete: "Delete Account",
    },
    cannot_verify_otp: "Cannot verify OTP",
    extension_link: "Extension installation link for shop login support",
    extension_video: "Video guide for adding a shop by login code",
    add_success: "Shop added successfully",
    login_success_account: "Account login successful",
    cannot_get_shop_info: "Cannot retrieve shop information",
    config_shop_success: "Shop configured successfully",
    selected_default: "Default shop selected",
    confirm_before_delete:
      "Are you sure you want to delete account {x}? Note that all automated settings of the shop may be deleted.",
    incorrect_account: "Incorrect account or password",
    get_method_login_error:
      "An error occurred while retrieving the OTP verification method. Please report to the administrator for assistance.",
    verify_sms:
      "Please confirm the link sent via SMS to connect the shop. Confirmation time is {x} seconds.",
    verify_email:
      "Please confirm the link sent via Email to connect the shop. Confirmation time is {x} seconds.",
    method_not_supported:
      "Verification method not supported. Please contact customer support for assistance.",
    wait_for_logging:
      "Please wait a moment, the system is logging in to the shop",
    method_not_found:
      "Login method not found. Please contact technical support for assistance.",
    login_success_shop: "Shop login successful",
    cannot_login_shop:
      "Cannot login to the shop! Please add the shop using the login code or contact the administrator for assistance",
    error_banned:
      "Cannot retrieve account data, please check and try again later!",
    error_require_captcha:
      "Captcha code required! Please login successfully on the browser and then login again on Atosa!",
    error_captcha: "Captcha is incorrect, please try again later!",
    error_notfound: "Account does not exist, please check and try again later!",
    error_need_otp: "OTP required, please enter the OTP code!",
    has_error: "An error occurred while logging in to the shop",
    connect_proxy_success: "Proxy connected successfully",
    connect_proxy_failed: "Proxy connection failed",
    invalid_proxy: "Invalid proxy",
    name: "Shop Name",
    added: "Shop Added",
    managed: "Managed Shop",
    select_for: "Please select a shop to use this feature",
    connected_to: "Connected to shop",
    connect_error:
      "An error occurred while connecting to the shop. Please try connecting again later!",
    connect_shop_error: "An error occurred while connecting to the shop",
  },
  // todo: end shop

  package: {
    has_expired: "Your service package has expired",
    x_has_expired:
      "Your {x} service package has expired. Please apply a new package to continue using it.",
    not_for_trial: "This feature is not available for trial packages",
  },
  // todo: end package

  sub_accounts: {
    invitation_send: "Invitation sent",
    send_invitation: "Send responsibility invitation",
    cancel_invitation: "Cancel invitation",
    has_no_sub_account: "No sub-account available",
    select_sub_account: "Select a sub-account",
    set_rule: "Set permissions",
    set_rule_success: "Permissions set successfully",
    delete_rule: "Delete permission",
    invitation_accounts: "List of invited accounts",
    invitation_shops: "List of invited shops",
    managed_shops: "List of managed shops",
    main_account: "Main account",
    invitation_by: "Invitation sender",
    show_rule: "View permission table",
    rule_table: "Permission table",
    add_account: "Add account",
  },
  // todo: end sub_accounts

  ads: {
    search_ads: "Search Ads",
    discover_ads: "Discover Ads",
    shop_ads: "Shop Ads",
    show_campaigns: "View Campaigns",
    create_campaigns: "Create Campaigns",
    update_campaigns: "Update Campaigns",
    add_keywords: "Add Keywords",
    added_keywords: "Added Keywords",
    update_keywords: "Update Keywords",
    delete_keywords: "Delete Keywords",
    config_auto: "Configure Automatic Ads",
    anti_click: "Anti-Fraud Click",
    ads_credit: "Ad Account Balance",
    ads_guide: "Shopee Ads Setup Guide",
    atosa_ads: "Atosa Ads",
    all_cpc_ads: "All CPC Ads",
    product_ads: "Product Ads",
    view_data_by_hour: "View Data by Hour",
    viewing_data_by_hour: "Exit Hourly Data View",
    exit_view_data_by_hour: "View Data by Hour",
    create_new_campaign: "Create New Campaign",
    select_ads_type: "Select Ad Type",
    low_balance_message:
      "Low ad account balance. Please top up to ensure uninterrupted ad.",
    surge: {
      title: "My Shopee Shop Ads",
      note: "Settings in the Shop Settings will apply to all running Shop Ads. The shop can adjust these settings at any time.",
      setting: "Optimize Bid Prices for Promotion Days",
    },
    conditional_configuration: "Conditional Automatic Configuration",
    conditional_automatic_configuration: "Conditional Automatic Configuration",
    optimize_based_on_conditional: "Optimize Based on Conditions",
    change_budget: "Automatically Adjust Budget",
    change_budget_configuration: "Automatic Budget Adjustment Configuration",
    mass_update: "Bulk Update",
    mass_configuration: "Bulk Configuration",
    select_metrics: "Select Metrics",
    campaign_list: "Campaign List",
    loading_campaign_list: "Loading Campaign List",
    all: "All Campaigns",
    all_campaign: "All Campaigns",
    with_low_performance: "Low Performance Campaigns",
    with_very_low_performance: "Very Low Performance Campaigns",
    with_average_performance: "Average Performance Campaigns",
    with_high_performance: "High Performance Campaigns",
    automatic_configuration: "Automatic Configuration",
    placeholder_search_by:
      "Search by product id, campaign id, campaign name, etc.",
    optimize_based_on_cir: "Optimize Based on CIR",
    optimize_audience_based_on_cir: "Optimize Audience Based on CIR",
    optimize_based_on_cir_advanced: "Advanced CIR Optimization",
    optimize_based_on_cir_configuration: "CIR Optimization Configuration",
    optimize_based_on_cir_advanced_configuration:
      "Advanced CIR Optimization Configuration",
    automatic_budget: "Automatic Budget",
    automatic_budget_configuration: "Automatic Budget Configuration",
    auto_bidding: "Automatic Bidding",
    manual_bidding: "Manual Bidding",
    search: "Search",
    targeting: "Explore",
    with_low_budget: "Low Budget Campaigns",
    running_out_of_budget_message:
      "The cost of the campaign is approaching the budget limit you set, and the campaign will pause when the budget runs out. Please increase the budget if you want to continue the campaign!",
    duration: "Duration",
    select_duration: "Set Start/End Date",
    select_products_for_creating_ad: "Select Products to Create Ads",
    anti_click_configuration: "Anti-Fraud Click Configuration",
    anti_click_label: {
      type1: "Conversion Rate % / Number of Clicks",
      type2: "CIR % (Cost / GMV)",
      minimum_clicks: "Minimum Number of Clicks",
      maximum_clicks: "Maximum Number of Clicks",
      broad_cir: "Extended CIR",
      direct_cir: "Direct CIR",
      maximum_cost: "Maximum Cost",
      check_if_gmv_by_0: "Check When No Orders (GMV = 0)",
      max_cost_if_gmv_by_0: "Maximum Cost of Keywords When No Orders",
      action_when_detect: "Action When Fraud Click is Detected",
      confirm_1:
        "You have enabled the No Orders mode but have not set a Maximum Cost. This could cause keywords to be stopped immediately! Do you still want to continue?",
      confirm_2:
        "You have enabled the No Orders mode but the Maximum Cost is too low. This could cause keywords to be stopped immediately! Do you still want to continue?",
    },
    general_label: {
      edit_amount: "Adjust Bid by Amount",
      pause_object: "Pause Keywords or Ads",
      not_exceed_max: "Do Not Exceed Maximum Bid",
      edit_by_realtime_cpc: "Adjust Bid by Daily CPC",
      higher_message: "Higher than the suggested bid amount or CPC value",
    },
    auto_position: "Maintain Automatic Position",
    advanced_auto_position: "Advanced Automatic Position Maintenance",
    auto_position_configuration: "Automatic Position Maintenance Configuration",
    advanced_auto_position_configuration:
      "Advanced Automatic Position Maintenance Configuration",
    auto_price: "Automatic Bidding",
    auto_price_configuration: "Automatic Bidding Configuration",
    auto_price_label: {
      lower_message: "Lower than the suggested bid amount or CPC value",
      higher_x_message:
        "Higher by x % than the suggested bid amount or CPC value",
      lower_x_message:
        "Lower by x % than the suggested bid amount or CPC value",
      by_amount_or_cpc:
        "Set bids based on Shopee’s suggested amount or CPC value",
    },
    auto_position_label: {
      from_position: "Start From",
      to_position: "Up To",
      input_from: "Enter Start Position",
      input_to: "Enter End Position",
      input_position: "Enter Position",
      always_above: "Always Maintain Above Position",
      always_below: "Always Maintain Below Position",
      bid_price_to_increase: "Additional Amount to Increase Position",
      bid_price_to_decrease: "Amount to Decrease to Lower Position",
      only_apply_with_exact: "Only Apply to Exact Match Keywords",
      advanced_note:
        "This feature only applies to keywords with Automatic Position Maintenance configuration",
      deduction_bid_price_when_target_position:
        "Amount Deducted When Target Position is Achieved",
      include_broad_keyword:
        "Note: In the configuration list with broad keywords, these keywords cannot check exact positions. Do you want to continue?",
      select_type: "Select Display Maintenance Type",
      select_type_search: "Increase Bid Until Displayed on Search Results Page",
      select_type_impression: "Increase Bid Until Impressions in Report",
      select_type_click: "Increase Bid Until Clicks in Report",
      reduce_if: "Amount Deducted After Displayed",
    },
    other_setups: "Other Settings",
    check_position_on: "Check Position On",
    advanced_configuration: "Advanced Configuration",
    configuration_active_day: "Active Day",
    configuration_active_day_list: "List of Active Days",
    advanced_mass_edit: "Advanced Bulk Configuration",
    edit_by_bid_price: "Adjust by Bid Amount",
    bonus_by_basic_config:
      "Increase by Amount Over Basic Configuration Max Bid",
    bonus_percent_by_basic_config:
      "Increase by Percentage Over Basic Configuration Max Bid",
    max_edit_max_bid_price: "Bulk Adjust Maximum Bid Price",
    apply_for_auto_position: "Apply to Position Maintenance Configuration",
    automatic_config: "Automatic Configuration",
    manual_config: "Manual Configuration",
    from: "From",
    to: "To",
    auto_quota_label: {
      unlimited: "Unlimited Budget",
      nothing: "Keep Existing Budget",
      pause: "Pause Campaign (Not Recommended)",
    },
    auto_cir_label: {
      to_reach_target: "To achieve the desired CIR level",
      allow_when_above_target:
        "Allow adjustment when CIR is above the set level",
      use_keyword_cir: "Use keyword CIR",
      use_campaign_cir: "Use campaign CIR",
      advanced_note_1: "Configuration will use daily CIR to optimize ads.",
      advanced_note_2:
        "This configuration is specific to Sale days and the set time frame. Outside this time frame, the system will use the basic CIR optimization configuration.",
      advanced_type_lte:
        "Apply to keywords with CIR less than or equal to the desired CIR level",
      advanced_type_gt:
        "Apply to keywords with CIR greater than the desired CIR level",
      advanced_type_not: "Apply to keywords with no CIR (CIR = 0)",
      max_bid_price_for_exact: "Maximum bid price for exact match keywords",
      max_bid_price_for_broad: "Maximum bid price for broad match keywords",
      bid_price_when_outside_runtime:
        "Bid price when outside the set time frame",
      max_cost_if_gmv_by_0: "Maximum ad cost when there are no orders",
      audience_allow_case_1:
        "Allow adjustment when audience CIR is above the set level",
      audience_pause: "Pause audience",
      audience_value: "Adjust premium level based on value",
      audience_reduce: "Gradually reduce premium level over time",
      audience_max_cost_if_gmv_by_0:
        "Maximum audience cost when there are no orders",
      audience_user_guide:
        "The system will increase the premium level for the audience when their CIR is lower than the set CIR or when CIR is 0 and there are no orders.",
    },
    time_based_bid_reduction: "Gradual reduction over time",
    action_when_exceeding_cost: "Action when exceeding cost",
    action_when_running_out_of_cir: "Action when exceeding the desired CIR",
    action_when_running_out_of_cost: "Action when out of cost",
    action_when_running_out_of_budget: "Action when out of budget",
    x_value_with_budget: "x [Value] % of the budget",
    x_with_ads_planning: "x ad plan",
    keyword_cpc: "Keyword CPC",
    ad_cpc: "Ad CPC",
    campaign_cpc: "Campaign CPC",
    shop_cpc: "Shop CPC",
    activity_frequency: "Activity frequency",
    each_30_minutes:
      "Run the rule every 30 minutes, and each run will take some time.",
    each_30_minutes_with_specific:
      "Run the rule every 30 minutes at specific times.",
    once_a_day:
      "Run only once a day, and the rule will automatically turn off after running.",
    clone_campaign_result: "Campaign cloning result",
    clone_success: "Campaign cloned successfully",
    clone_fail: "Campaign cloning failed",
    cannot_clone: "Cannot clone campaign",
    manual_shop_ads: "Shop ads (Manual)",
    auto_shop_ads: "Shop ads (Automatic)",
    all_ads: "All ads",
    targeting_ads: "Explore ads",
    manual: "Manual",
    auto: "Automatic",
    manual_all_ads: "Manual All Ads",
    auto_all_ads: "Automated All Ads",
    manual_search_ads: "Manual Search Ads",
    auto_search_ads: "Automated Search Ads",
    manual_targeting_ads: "Manual Targeting Ads",
    auto_targeting_ads: "Automated Targeting Ads",
    create_campaigns_result: "Campaign Creation Results",
    cannot_create_campaign: "Unable to Create Campaign",
    back_to_campaigns: "Return to Campaigns Page",
    there_are_multiple_ongoing_message:
      "Multiple ads are currently running for this product. To maximize effectiveness, Shopee's system displays only one ad to buyers at a time.",
    there_are_multiple_ongoing_see_detail: "View Other Ads for This Product",
    campaign_is_good: "The Campaign is Performing Well.",
    campaign_is_not_good:
      "The Campaign is Underperforming. Please Optimize the Ads and Product.",
    mass_setup_auto_configuration: "Bulk Automatic Configuration",
    mass_setup_anti_click_configuration: "Bulk Anti-Click Fraud Configuration",
    mass_setup_optimize_based_on_cir_configuration:
      "Bulk Optimization Based on CIR Configuration",
    mass_setup_conditional_automatic_configuration:
      "Bulk Conditional Automatic Configuration",
    mass_setup_advanced_configuration: "Bulk Advanced Configuration",
    mass_delete_auto_configuration: "Bulk Delete Automatic Configuration",
    mass_delete_advanced_auto_configuration:
      "Bulk Delete Advanced Automatic Configuration",
    mass_delete_anti_click_configuration:
      "Bulk Delete Anti-Click Fraud Configuration",
    mass_delete_optimize_based_on_cir_configuration:
      "Bulk Delete Optimization Based on CIR Configuration",
    max_edit_max_bid_price_of_auto_position:
      "Adjust Maximum Bid Price (Maintain Position)",
    mass_delete_conditional_automatic_configuration:
      "Bulk Delete Conditional Automatic Configuration",
    mass_add_keywords: "Bulk Add Keywords",
    mass_edit_keywords_bid_price: "Bulk Edit Keyword Bid Prices",
    mass_edit_keywords_by_condition: "Bulk Edit Keywords by Condition",
    mass_edit_discovery_bid_price: "Bulk Edit Discovery Bid Prices",
    resume_pause_delete_configuration:
      "Enable / Pause / Delete Automatic Configuration",
    resume: "Resume",
    pause: "Pause",
    auto_configuration: "Auto configuration",
    recommend_price: "Recommended price",
    new_custom_audience: "Create new audience",
    audience_note:
      "Your ads will automatically use the Custom Audience feature when you create a Custom Audience.",

    active: "Activate",
    bid_price_when_not_cpc: "Bid price when CPC is not available",
    i_or_d_by_rmd_or_cpc_by_amount:
      "Increase / decrease bid by the amount of Suggested Price or CPC",
    i_or_d_by_rmd_or_cpc_by_percent:
      "Increase / decrease bid by the percentage of Suggested Price or CPC",
    set_by_rmd_or_cpc: "Set bid by Suggested Price or CPC",
    atosa_use_0_note:
      "Atosa will use Shopee’s Suggested Price if the CPC value is 0.",
    average_ranking: "Average position",
    convert_position_table:
      "Position conversion table between Shopee Web and App.",
    website_position: "Position on website",
    mobile_position: "Position on mobile",
    auto_cir_advanced_note:
      "Configuration will use daily CIR rate to optimize ads.",
    shop_page: "Shop homepage (Default)",
    linked_page: "Linked page",
    edit_image: "Edit image",
    suggested: "Suggested level",
    condition_label: {
      cpc_today: "Percentage of keyword CPC today",
      cpc_week: "Percentage of keyword CPC over the past 7 days",
      cpc_month: "Percentage of keyword CPC over the past 30 days",
      cpc_campaign_today: "Percentage of campaign CPC today",
      cpc_campaign_week: "Percentage of campaign CPC over the past 7 days",
      cpc_campaign_month: "Percentage of campaign CPC over the past 30 days",
      cpc_shop_today: "Percentage of shop CPC today",
      cpc_shop_week: "Percentage of shop CPC over the past 7 days",
      cpc_shop_month: "Percentage of shop CPC over the past 30 days",
      add_search_keyword: "Add search command in report",
    },
    create_shop_flash_sale: "Create shop flash sale",
    create_shop_vouchers: "Create shop vouchers",
    auto_budget: "Automatic budget",
    update_budget_confirm: "Are you sure you want to update the ad budget?",
    error_with_exporting: "There was an error exporting the report",
    error_with_exporting_21: "There was an error exporting the report 2.1",
    error_with_exporting_22: "There was an error exporting the report 2.2",
    error_with_getting_products: "There was an error retrieving product data",
    error_with_getting_campaigns:
      "There was an error retrieving the list of campaigns",
    error_with_getting_campaign_detail:
      "There was an error retrieving campaign information",
    error_with_creating_campaign: "There was an error creating the campaign",
    error_with_add_keywords: "There was an error adding keywords",
    just_select_only_one_1:
      "You can only use one of the automatic configurations. If you select automatic CIR optimization configuration, other configurations will be deleted or paused (except Anti-click). Do you want to continue?",
    just_select_only_one_2:
      "You can only use one of the automatic configurations. If you select automatic bidding configuration, other configurations will be deleted or paused (except Anti-click). Do you want to continue?",
    just_select_only_one_3:
      "You can only use one of the automatic configurations. If you select automatic position maintenance configuration, other configurations will be deleted or paused (except Anti-click). Do you want to continue?",
  },
  // todo: end ads

  create_ads: {
    auto_bidding: "Automatic",
    manual_bidding: "Custom",
    custom: "Choose a value",
    auto_bidding_message:
      "Shopee will continuously optimize Ads to achieve stable ROAS.",
    let_shopee_audience:
      "Let Shopee help your ads reach the right potential buyers.",
    prioritise_specific:
      "Prioritize showing ads to buyers within the custom audience list you set.",
  },

  day: {
    flash_sale: "Flash Sale Day",
    before_flash_sale: "Before Flash Sale Day",
    after_flash_sale: "After Flash Sale Day",
    mini_spike_day: "Mini Spike Day",
    specific_day: "Specific Day",
    remaining_days: "Remaining Days",
    past3days: "Past 3 Days",
    past5days: "Past 5 Days",
    past7days: "Past 1 Week",
    past14days: "Past 2 Weeks",
    past21days: "Past 3 Weeks",
    past30days: "Past 1 Month",
    past60days: "Past 2 Months",
    past90days: "Past 3 Months",
    from_start_month: "From Start of Month",
    range: "Time Range",
    realtime: "Current time",
    daily: "Daily",
  },
  // todo: end day

  metric: {
    average_ranking: "Average Ranking",
    impressions: "Impressions",
    clicks: "Clicks",
    ctr: "Click-Through Rate (CTR)",
    conversions: "Conversions",
    direct_conversions: "Direct Conversions",
    items_sold: "Items Sold",
    direct_items_sold: "Direct Items Sold",
    direct_gmv: "Direct GMV",
    expense: "Expense",
    direct_roi: "Direct ROI (ROAS)",
    direct_cir: "Direct CIR (ACOS)",
    conversion_rate: "Conversion Rate",
    direct_conversion_rate: "Direct Conversion Rate",
    cost_per_conversion: "Cost Per Conversion",
    cost_per_direct_conversion: "Cost Per Direct Conversion",
    shop_impressions: "Shop Impressions",
    shop_clicks: "Shop Clicks",
    shop_ctr: "Shop CTR",
    product_impressions: "Product Impressions",
    product_clicks: "Product Clicks",
    product_ctr: "Product CTR",
    plan: "Plan",
    complete: "Complete",
    add_to_cart_units: "Add to Cart Units",
    orders: "Orders",
    ads_orders: "Ads Orders",
    ads_expense: "Ads Expense",
  },
  // todo: end metric

  keyword: {
    all: "All Keywords",
    exact: "Exact Match Keywords",
    broad: "Broad Match Keywords",
    saved_files: "Saved Keyword Files",
    limit_message:
      "Search volume and the number of keywords returned are limited. Please upgrade your plan to view all data. Remaining searches",
    show_current_keyword: "Show Current Keyword",
    open_current_keyword: "Open Current Keyword",
    save_file: "Save Keyword File",
    save_selected: "Save Selected Keywords",
    save_all: "Save All Keywords",
    has_no_keyword: "No keywords yet, please add your keywords",
    add_keywords: "Add Keywords",
    has_no_connected_message:
      "No connection to Shopee seller account, please select another account and try again",
    file: "Keyword File",
    empty_to_save: "You have no keywords yet, please add keywords to save!",
    confirm_save_file_x_name:
      "Are you sure you want to save the keyword file with the name {x}?",
    chart_message: "Chart showing keyword searches across devices",
    enter_keyword_analysis: "Enter keyword for analysis",
    select_product: "Select Product to Search",
    research_keyword: "Keyword Analysis",
    total_shopee_volume: "Total Shopee Searches",
    getting_shopee_data: "Retrieving data from Shopee",
    updated_shopee_data: "Updated Shopee Search Volume and Bids",
    can_not_connect:
      "Cannot connect to account, please check and try again later!",
    error_while_get_data:
      "Error retrieving data, please check and try again later!",
    result_not_found_message:
      "No results found for keyword {x} on Atosa system. Added search results from Shopee",
    start_getting_shopee_data: "Start Retrieving Data from Shopee",
    import_note:
      "Please save keywords in the first column, bids in the second column (bids are optional)",
    add_all: "Add All Keywords",
    add_top_x: "Add Top {x} Keywords",
    confirm_and_add: "Confirm and Add Keywords",
    added_keywords: "Added Keywords",
    pause: "Pause Keywords",
    type: "Keyword Type",
    report: "Keyword Report",
    word_count: "Keyword Word Count",
    with_very_low_performance: "Keywords with Very Low Performance",
    with_low_performance: "Keywords with Low Performance",
    with_average_performance: "Keywords with Average Performance",
    with_high_performance: "Keywords with High Performance",
    report_analysis: "Keyword Report Analysis",
    update_existed_file: "Update Existing Keyword File",
    cannot_delete_all_keywords:
      "Cannot delete all keywords! You must keep at least one keyword",
    delete_confirm:
      "Do you want to delete the selected keywords? Currently, Shopee has removed the feature to delete keywords, so deleted keywords will be paused. Note that campaigns must be set to end in order to delete keywords!",
    delete_x_confirm:
      'Do you want to delete the keyword "{x}"? Currently, Shopee has removed the feature to delete keywords, so deleted keywords will be paused. Note that campaigns must be set to end in order to delete keywords!',
    not_found: "No keywords found",

    dont_use_restricted: "Do not use restricted keywords",
    add_to_campaigns: "Add keywords to campaigns",
    match_to_original_keyword: "Match with original keyword",
    not_match_to_original_keyword: "Does not match with original keyword",
    existing_in_campaign: "Already in campaign",
    not_existing_in_campaign: "Not in campaign",
    existed: "Keyword Exists",
    not_existed: "Keyword Does Not Exist",
    file_list: "Keyword File List",
    keyword_number: "Number of Keywords",
    not_files: "No files or no suitable files",
    list: "Keyword List",
    volume_at_saving: "Search Volume at Save",
    bid_price_at_saving: "Bid Price at Save",
    current_volume: "Current Search Volume",
    current_bid_price: "Current Bid Price",
    your_bid_price: "Your Bid Price",
    update_note:
      "Your changes are temporary, please click save to update the data on Atosa",
    add_to_current_keyword: "Add to [Current Keyword]",
    update_file_confirm: "Are you sure you want to update this keyword file?",
    can_not_connect_fff:
      "Cannot connect to account, please check and try again later!",
  },
  // todo: end keyword

  product: {
    get_success: "Product data retrieved successfully",
    list: "Product List",
    change_name_note:
      "Note: Use the preview feature to check product names before bulk updating!",
    add_to_group: "Add product to group",
    remove_from_group: "Remove product from group",
    restricted_keywords_file: "Restricted Keywords File List",
    add_restricted_keywords_file: "Add Restricted Keywords File",
    update_restricted_keywords_file: "Update Keywords in File",
    add_restricted_keywords: "Add Restricted Keywords",
    delete_restricted_keywords: "Delete Restricted Keywords",
    group: "Product Group",
    group_list: "Product Group List",
    add_group: "Add Product Group",
    group_name: "Group Name",
    restricted_keywords: "Restricted Keywords",
    preview_products: "Preview Products",
    mass_add_text: "Bulk Add Text",
    mass_remove_text: "Bulk Remove Text",
    before_name: "Before Product Name",
    after_name: "After Product Name",
    text_insert_position: "Text Insert Position",
    skip_products_preview: "Skip Preview",
    mass_edit_name: "Bulk Edit Product Name",
    add_text: "Add Text to Product Name",
    replace_text: "Replace Text in Product Name",
    remove_text: "Remove Text from Product Name",
    mass_add_frame: "Bulk Add Image Frame",
    mass_remove_frame: "Bulk Remove Image Frame",
    id: "Product ID",
    edit_name: "Edit Product Name",
    edit_cover_image: "Change Cover Image",
    add_frame: "Add Image Frame",
    history_edit_name: "Name Change History",
    history_edit_image: "Image Change History",
    history_edit_name_of: "Name Change History of Product",
    history_edit_image_of: "Image Change History of Product",
    input_remove_text: "Enter the text you want to remove",
    uppercase_letter: "Case Sensitive",
    remove_only_once: "Remove Only Once",
    edit_product_cover_image: "Change Product Cover Image",
    add_frame_product_image: "Add Frame to Product Image",
    edit_product_cover_image_note:
      "Note: Before changing the cover image, you need to save the original image. If you need to recover, you can redownload the original image when editing the product.",
    drag_and_drop_image: "Drag image here or",
    click_to_upload: "Click to upload",
    required_image_format: "Requires jpg/png format",

    old_image: "Old Image",
    new_image: "New Image",
    use_other_image: "Use Another Image",
    use_other_frame: "Use Another Frame",
    confirm_edit_cover: "Confirm Change Cover Image",
    attention_1:
      "Before changing the cover image, you need to save the original image. If you need to recover, you can redownload the original image when editing the product.",
    attention_2: "Use .png files for image frames.",
    attention_3: "Download other cover image templates",
    edit_cover_image_only: "Edit Cover Image Only",
    apply_for_multiple_images: "Apply to Multiple Images",
    all_frames: "All Frames",
    frames_for_spike_day: "Frames for Flash Sale Day",
    upload_frames: "Upload Frames",
    check_other_frames: "Check Other Frames",
    select_image_to_add_frames: "Select Image to Add Frames",
    adding_frame: "Adding Frame",
    confirm_add_frame: "Confirm Add Frame",
    recover_images: "Recover Images",
    remove_frame: "Remove Frame",
    recover_cover_image: "Recover Cover Image",
    recover_old_image: "Recover Old Image",
    current_name: "Current Product Name",
    new_name: "New Product Name",
    replace_first_only: "Replace Only the First Found Text",
    replace_with: "Replace With",
    expected_replace_text: "Text to Replace",
    change_name: "Change Product Name",
    recover_old_name: "Recover Old Product Name",
    old_name: "Old Product Name",
    current_cover_image: "Current Cover Image",
    cover_image_after_remove_frame: "Cover Image After Removing Frame",
    delete_frame_confirm: "Are you sure you want to delete the frame?",
    delete_frame_success: "Frame deleted successfully",
    recover_old_name_confirm:
      "Are you sure you want to recover the old product name?",
    recover_old_image_confirm:
      "Are you sure you want to recover the old image?",
    change_name_confirm: "Are you sure you want to change the product name?",
    cannot_recover_old_image:
      "Cannot recover the original image of this product",
    recover_image_success: "Image recovered successfully",
    updated_time: "Update Time",
    current_time: "Update Time",
    add_frame_confirm: "Are you sure you want to add a frame to the product?",
    edit_cover_image_confirm:
      "Are you sure you want to change the cover image for the product?",
    process_adding_frame_complete: "Frame addition process completed",
    error_with_adding_frame: "Error occurred during frame addition",
    update_cover_image_success: "Cover image updated successfully",
    delete_group_confirm: "Are you sure you want to delete the product group?",
    delete_product_from_file_confirm:
      "Are you sure you want to remove this product from the file?",
    delete_product_from_group_confirm:
      "Are you sure you want to remove this product from the group?",
    name_too_long: "Error: Product name is too long",

    all: "All Products",
    select_multiple: "Select Multiple Products",
    current_list: "Currently Displayed Product List",
    name: "Product Name",
    model_id: "Model ID",
    model_name: "Model Name",
    original_price: "Original Price",
    current_price: "Current Price",
    stock: "Stock",
    flash_sale_price: "Flash Sale Price",
    promotion_quantity: "Promotion Quantity",
    limit: "Limit",
    download_file_success: "Product File Downloaded Successfully",
  },
  // todo: end product

  planning: {
    gmv: "GMV Plan",
    cost: "Cost Plan",
    order: "Order Plan",
    traffic: "Traffic Plan",
    cir: "CIR Plan",
    roas: "ROAS Plan",
  },
  // todo: end planning,

  center: {
    go_to_shopee_ads: "Go to Shopee Ads",
    use_cost_ads: "Use Advertising Cost",
    placed_order: "Placed Orders",
    confirmed_order: "Confirmed Orders",
    paid_order: "Paid Orders",
    sales: "Sales",
    orders: "Orders",
    conversions_rate: "Conversion Rate",
    sales_on_orders: "Sales per Order",
    visitor: "Visitors",
    page_views: "Page Views",
    aov: "Average Order Value",
    customer_segment: "Customer Segment by Purchase Value",
    pricing_segment: "Pricing Segment",
    add_to_cart_rate_on_view: "% Add to Cart / Page View",
    placed_units_all: "Units Sold (All Orders)",
    placed_units_placed: "Units Sold (Placed Orders)",
    placed_units_confirmed: "Units Sold (Confirmed Orders)",
    placed_units_paid: "Units Sold (Paid Orders)",
    placed_units_on_add_to_cart_units_rate: "% Units Sold / Add to Cart",
    sales_all: "Sales (All Orders)",
    sales_placed: "Sales (Placed Orders)",
    sales_confirmed: "Sales (Confirmed Orders)",
    sales_paid: "Sales (Paid Orders)",
    today_until_x: "Until {x} Today",
    vs_x_yesterday: "compared to {x} Yesterday",
    vs_previous_day: "compared to Previous Day",
    vs_7_days: "compared to 7 Days Ago",
    vs_30_days: "compared to 30 Days Ago",
    by_day: "By Day",
    by_week: "By Week",
    by_month: "By Month",
    by_year: "By Year",
    vs_previous_week: "compared to Previous Week",
    vs_previous_month: "compared to Previous Month",
    vs_previous_year: "compared to Previous Year",
    past7days: "Past 7 Days",
    past3days: "Past 3 Days",
    cannot_show_chart:
      "Cannot display chart due to large data size. Feature is being updated",
    cancel_order_rate: "Cancellation Rate",
    improve_conversions_rate: "Shop, please improve your conversion rate",
    chat_response_rate: "Chat Response Rate",
    shop_rating: "Shop Rating",
    ratings: "Ratings",
    should_respond_chat: "Shop should respond to chats more actively",
    ask_for_positive:
      "Hey Shop, ask customers for positive reviews to attract more attention to your products",
    response_time: "Response Time",
    respond_customers_faster: "Please respond to customers faster",
    improvable: "Improvement Needed",
    high_quality: "Good Listing Quality",
    more_x_products_need_to_improve:
      "More than {x}% of products need improvement",
    very_good: "Very Good! Your shop has no products needing improvement",
    note_1:
      "The listing quality of many products in your shop is suggested for improvement. Good listing quality will attract buyers and increase visibility competitiveness.",
    note_2:
      "Please review some examples of products with good listing quality and suggested improvements below.",

    note_3: "Please update products according to the suggestions below, shop",
    product_tab_1: "Product name is too short",
    product_tab_2: "Description is too short",
    product_tab_3: "Incorrect category",
    product_tab_4: "Too few images",
    product_tab_5: "Missing size information",
    suggest_seo_name: "Suggested SEO Name",
    update_by_suggested: "Update according to suggestions",
    last_updated: "Last Updated",
    recommend: "Recommendation",
    update_by_same_category: "Update with corresponding category",
    edit_size: "Enter package size",
    campaigns_effectiveness: "Campaign Effectiveness",
    ads_effectiveness: "Advertising Effectiveness",
    ongoing_campaigns: "Number of Active Campaigns",
    ongoing_campaigns_with_daily_budget:
      "Number of Active Campaigns with Daily Budget",
    ongoing_campaigns_with_total_budget:
      "Number of Active Campaigns with Total Budget",
    sum_daily_budget: "Total Daily Budget",
    sum_total_budget: "Total Overall Budget",
    optimize_or_pause_campaigns_note:
      "Consider optimizing or pausing ineffective ad campaigns below, shop.",
    campaigns_with_low_performance: "List of Low-Performance Ad Campaigns",
    within_few_hours: "Within a Few Hours",
    flash_sale_report: "Flash Sale Data Report",
    add_to_cart_units_pv: "Add-to-Cart Rate / Page View",
    confirmed_units_add_to_cart_units: "Confirmed Orders Rate / Add-to-Cart",
    product_conversion_report: "Product Conversion Data Report",
    confirmed_buyers_placed_buyers: "Confirmed Buyers Rate / Placed Orders",
    uv_pv: "Visitor Rate / Page View",
    atc_uv_uv: "Add-to-Cart Rate / Visitor Rate",
    placed_buyers_atc_uv: "Placed Orders Rate / Add-to-Cart",
    atc_unit_num_atc_uv: "Add-to-Cart Units per Visitor",
    placed_unit_num_atc_unit_num: "Placed Orders per Add-to-Cart Unit",
    products_overview_report: "Product Overview Data Report",
    shop_overview_report: "Shop Overview Data Report",
    customer_insights_of_products: "Customer Insights by Product",
    customer_insights_of_all_products: "Customer Insights for All Products",
    select_product_to_analyze: "Select a Product to Analyze",
    shop_in_sync_orders_process: "The shop is updating order data",
    select_shop_to_use_feature: "Select a shop to use this feature",
    shop_need_to_link: "The shop needs to be linked to use this feature",
    link_account: "Link Account",
    analyzing_data: "Analyzing Data",
    order_number: "Order Number",
    retail_gmv: "Retail GMV",
    bundled_gmv: "GMV sold with other products",
    since_begin_year: "Since the Beginning of the Year",
    since_begin_month: "Since the Beginning of the Month",
    only_in_year: "Only This Year",
    only_in_month: "Only This Month",
    up_to_now: "Up to Now",
    from_month_to_month: "From Month to Month",
    top_5_add_on_products_with_highest_gmv:
      "TOP 5 ADD-ON PRODUCTS WITH HIGHEST GMV",
    top_5_add_on_products_with_most_buyers:
      "TOP 5 ADD-ON PRODUCTS WITH MOST BUYERS",
    top_5_city_with_highest_gmv: "TOP 5 CITIES WITH HIGHEST GMV",
    top_5_city_with_most_buyers: "TOP 5 CITIES WITH MOST BUYERS",
    province_city: "Province / City",
    buyer: "Number of Buyers",
    items_sold_order: "Average Sales per Order",
    return_buyers: "Number of Returning Buyers",
    highest_purchase_time: "Peak Purchase Time",
    city_with_most_buyers: "City with Most Buyers",
    list_of_add_on_products: "LIST OF ADD-ON PRODUCTS",
    purchased_number: "Number of Add-On Purchases",
    shopee_master: "SHOPEE MASTER",
    competitive_products: "COMPETITIVE PRODUCTS",
    shop_analysis_by_city: "SHOP ANALYSIS BY CITY",
    shop_analysis_by_period: "SHOP ANALYSIS BY PERIOD",
    add_to_cart_units_30_days: "Add-to-Cart Units (Last 30 Days)",
    items_sold_30_days: "Items Sold (Last 30 Days)",
    sales_30_days: "Sales (Last 30 Days)",
  },
  // todo: end center

  flash_sale: {
    create_new_by_multiple_time_slot:
      "Create Flash Sale by Multiple Time Slots",
    detail: "Details of Shop Flash Sale Program",
    loading: "Loading Flash Sale List",
    create_new: "Create New Flash Sale Program",
    title: "Shop Flash Sale",
    saved_file: "Saved Flash Sale File",
    advanced_saved_file: "Advanced Flash Sale File",
    mass_resume: "Resume Flash Sale in Bulk",
    mass_pause: "Pause Flash Sale in Bulk",
    mass_delete: "Delete Flash Sale in Bulk",
    enabled_for: "Enable Flash Sale",
    total_available: "Number of Participating Products",
    no_of_reminders_set: "Number of Reminder Set",
    no_of_product_clicks: "Number of Clicks/View",
    enable_disable: "Enable/Disable",
    delete: "Delete Data",
    create_file: "Create Flash Sale File",
    edit_products: "Update Product Information",
    enable_auto_config: "Enable Auto Configuration",
    disable_auto_config: "Disable Auto Configuration",
    search_placeholder: "Search by File Name, Product ID, SKU...",
    auto_config_message: "Running automatically. Time slot:",
    auto_config_message_2: "Running automatically",
    no_of_product: "Number of Products",
    setup_auto_config: "Setup Auto Flash Sale Configuration",
    random_message:
      "The system will randomly select products from the file and create Flash Sales across all time slots.",
    select_time_slot: "Select Shop Flash Sale Time Slots",
    day: "Day",
    time_slots_selected: "Number of Time Slots Selected",
    confirm_selected: "Confirm Time Slots",
    update_file: "Update Flash Sale File",
    setup_products_note:
      "Set % Discount and % Stock to run automatic Flash Sale creation",
    system_will_create_before_x_hours:
      "The system will automatically create the Flash Sale Program {x} hours before",
    create_before_x_hours:
      "Create data {x} hours before, (minimum {min} hours, maximum {max} hours)",
    creation_time_slot: "Flash Sale Start Time Slot",
    show_not_created_only: "Show Only Products Not Yet Created Flash Sale",
    filename: "Flash Sale File Name",
    save_file: "Save Flash Sale File",
    copy_time_slot: "Copy Flash Sale Time Slots",
    select_time_slot_manually: "Select Time Slots Manually",
    select_time_slot_auto: "Automatically Select Corresponding Time Slots",
    setup_advanced_configuration:
      "Setup Advanced Flash Sale Auto Configuration",

    all_day: "Select All Day",
    half_a_day_from: "Run Half Day from",
    custom_time: "Custom Time",
    download_template_file: "Download Template File",
    download_products_file: "Download Products File",
    import_products: "Import Products",
    drag_and_drop_or: "Drag file here or",
    click_to_upload: "Click to upload",
    file_format_required: "Requires *.xlsx/*.xls format",
    excel_code_title:
      "Excel formula to calculate promotional price as 80% of the original price or the current promotional price of the product",
    excel_code: "=INT([Original Price Column | Selling Price Column] * 80%)",
    excel_code_title_2:
      "Excel formula to get 10% of the product stock quantity for the flash sale",
    excel_code_2: "=INT([Stock Column] * 10%)",
    variations_uploaded: "Product variations uploaded successfully",
    add_products_to_file: "Add Products to File",
    update_products_confirm:
      "Are you sure you want to update the product list?",
    change_config_status_confirm:
      "Are you sure you want to change the status of the selected auto configurations?",
    invalid_discount_price: "Invalid flash sale promotional price",
    invalid_quantity: "Invalid promotional quantity",
    enable_time_slots_confirm:
      "Are you sure you want to enable the selected Flash Sale program?",
    disable_time_slots_confirm:
      'Disabling this program means you agree to remove all products registered for the Shop Flash Sale. If you want to switch the program status back to "Enabled," you will need to re-register each product for the program.',
    delete_confirm:
      "Are you sure you want to delete the selected Flash Sale program?",
    mass_delete_confirm:
      "Are you sure you want to delete all selected Flash Sale programs?",
    delete_file_confirm: "Do you want to delete this Flash Sale product file?",
    save_products_to_file: "Save Products to File",
    promotion_quantity: "Promotional Quantity",
    campaign_stock: "Promotional Product Quantity",
    purchase_limit: "Order Limit",
    discount: "Discount",
    discount_percent_between_x_y:
      "Discount percentage must be greater than {x} and less than {y}",
    promotion_quantity_between_x_y:
      "Promotional quantity must be greater than {x} and less than {y}",
    promotion_quantity_lt_x: "Promotional quantity must be less than {x}",
    evenly_every_days:
      "Total promotional quantity must be evenly distributed across the days.",
    api_error_response:
      "Sorry, this product does not meet the conditions. Please refer to the information page on Shop Flash Sale program regulations.<br/>Error Code",
    updated_message: "Product information updated",
    create_title: "Total Number of Available Products",
    you_have_enabled: "You have selected",
    products_for_selected_time_slots: "Products for the selected time slots",
    back_to_list_message:
      "Please add and activate each product in the Shop Flash Sale section.",
    discount_percent_is_higher_x: "Discount percentage is higher than {x}",
    discount_percent_is_higher_x_warning:
      "In the list of products creating Flash Sale, there are promotions with a higher discount than {x}, which may affect sales revenue. Do you want to continue creating?",
    attention_when_create:
      "<br/>Warning: Classification when creating flash sale.<br/>Error Code",
    live_period: "Flash Sale Duration",
  },
  // todo: end flash_sale
};
// end json



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js